module.exports = __webpack_public_path__ + "img/avatar4.661489cc.png";